define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/dom-style",
	"dojo/on",
	"dojo/promise/all",
	"dojo/query",
	"dojo/store/Memory",
	"dojo/topic",
	"dojo/when",
	"lodash",
	"csi",
	"csi/_base/Deferred",
	"csi/action",
	"csi/api",
	"csi/constants",
	"csi/def",
	"csi/def/Heading",
	"csi/gallery/_base",
	"csi/gallery/_DndGalleryMixin",
	"csi/heading/_base",
	"csi/heading/Specs",
	"csi/html",
	"csi/html/Widget",
	"csi/middleware/common",
	"csi/middleware/customView/customViewService",
	"csi/middleware/customView/options/GalleryCustomViewOptionsStore",
	"csi/middleware/customView/options/GalleryOptionsTab",
	"csi/middleware/customView/options/CustomViewOptions",
	"csi/model/image",
	"csi/prefs/_base",
	"csi/locale",
	"csi/reflection",
	"csi/service/imageService",
	"csi/service/viewService",
	"csi/state",
	"csi/store/Nodes",
	"csi/store/PageSize",
	"csi/store/PageSizeWithoutAll",
	"csi/store/Values",
	"csi/store/ValuesFromPairs",
	"csi/types",
	"csi/utility/coreUtility",
	"csi/view/_CustomViewQueryMixin",
	"csi/view/_QueryMixin",
	"csi/xml",
	"src/c8-platform/type/customView",
	"./GalleryPlaceholder",
	"./Preferences",
	"dojo/text!csi/templates/gallery.html",

	"csi/view/ToolbarAttributes",
	"./ToolbarBatchFilter",
	"csi/view/ToolbarPluginSuspend",
	"csi/widget/InvalidMessage"
], function(array, declare, lang, domClass, domConstruct, domStyle, on, all, query, Memory, topic, when, _,
	csi, Deferred, csiAction, api, constants, def, Heading, csiGallery, _DndGalleryMixin, csiHeading, Specs, html, HtmlWidget,
	{convertEnumToComponentItem}, {getCustomViewClassImageLabels}, GalleryCustomViewOptionsStore, GalleryOptionsTab,
	{IMAGE_DIMENSION_MIN}, {IMAGE_SIZE_CUSTOM, getImagePixelSizeByRowsPerPage, getImageSizeBySize, isImageLabelValid},
	csiPrefs, locale, reflection, {waitForImagesToLoad}, {collectSpecDependencyPaths}, state, Nodes, PageSize, PageSizeWithoutAll, Values, ValuesFromPairs,
	types, {isDefined}, _CustomViewQueryMixin, _QueryMixin, xml, {CustomViewVersion}, GalleryPlaceholder, Preferences, template) {

	var _groupHeaderStyleStore;
	var _templateStore;

	csiAction.registerControllers("Gallery", {
		AggregateFrom: "csi/gallery/AggregateFrom",
		Copy: "csi/gallery/Copy",
		CustomViewManage: "csi/gallery/GalleryCustomViewController",
		CustomViewManageButton: "csi/gallery/GalleryCustomViewController",
		CustomViewSaveAs: "csi/gallery/GalleryCustomViewController",
		Delete: "csi/gallery/Delete",
		TableSuspend: "csi/gallery/Suspend",
		Insert: "csi/gallery/New",
		MoveDown: "csi/gallery/MoveUpDown",
		MoveUp: "csi/gallery/MoveUpDown",
		New: "csi/gallery/New",
		PlotExpandCollapse: "csi/gallery/PlotExpandCollapse"
	});

	var FROZEN_TABLE = "csi-frozen-gallery-table";
	var FROZEN_THEAD = "csi-frozen-gallery-table-head";
	var FROZEN_TBODY = "csi-frozen-gallery-table-body";
	var FROZEN_ROW = "csi-frozen-gallery-table-block-row";
	var FROZEN_THEAD_CELL = "csi-frozen-gallery-table-header";
	var FROZEN_TBODY_CELL = "csi-frozen-gallery-table-cell";
	var FROZEN_TABLE_HIDDEN_CELL = "csi-frozen-gallery-hidden-cell";
	var FROZEN_CELL_PLOT_CONTENT = "csi-frozen-gallery-expand-all-plot-content";

	function _filterDimension(/*Query*/qn, /*Spec*/spec, /*Store*/valuesStore, /*Number*/index) {
		if (spec && (index >= 0)) {
			var q = {};
			q[valuesStore.indexProperty] = index;

			valuesStore.query(q, {useCache: true}).forEach(function(item) {
				spec.applyFilter(qn, xml.OP_EQUALS, valuesStore.getIdentity(item));
			});
		}
	}

	function _getPlotCellTitle(/*String?*/rowName, /*String?*/colName) {
		// summary: return combined text for cell row and column names
		if (!rowName && (rowName != null)) {
			rowName = locale.resource("BlankValue");
		}

		if (!colName && (colName != null)) {
			colName = locale.resource("BlankValue");
		}

		return (rowName || "") + (rowName && colName ? " / " : "") + (colName || "");
	}

	return declare([HtmlWidget, _QueryMixin, _CustomViewQueryMixin, _DndGalleryMixin], {
		// base widget members
		bDisableContentActions: true,
		customViewOptionsComponent: GalleryOptionsTab,
		customViewOptionsStore: GalleryCustomViewOptionsStore,
		plugins: ['fullScreen', 'print', 'pdf', 'attributes', 'refresh', '|', 'pageSize', '|', 'tableSuspend', 'filter'],
		pluginsRight: ['fullScreen', 'print', 'pdf'],
		prefClass: Preferences,
		splitterType: "gallery",
		templateString: template,

		// Boolean: allow data points to be changed through custom views - true if key with "*" in template
		bAllowDataPoints: true,

		// Boolean: indicates if template height is combination of image and attributes (false if they appear side by side)
		//bImageAboveAttrs: false,

		// Boolean: true when grouping by row or column or both
		//bPlot: false,

		// DOMNode: root element of block (each block item includes this element)
		blockNode: null,

		//Boolean: option to display full size image if image size requested is bigger than Largest
		bAllowOriginal: false,

		//Boolean: option to hide view message node
		bShowMessageNode: true,

		// C8AttributeKey: attributes keys used to group gallery view in rows and columns
		//columnGroupAttribute: null,
		//rowGroupAttribute: null,

		/** @property {boolean} disableAdHoc - disable and hide batch filters */
		//disableAdHoc: false,

		// Boolean: whether to show nodes (true) or only summary with number of nodes (false) when grouping
		//expandAllGroups: false,

		// Number: width of attribute area per block
		//galleryAttributeWidth: 0,

		// String: label to use when rendering image
		//galleryImageLabel: null,

		// Number: max height and width of image per block
		//galleryImageWidth: 0,
		//galleryImageHeight: 0,

		// Number: number of rows per page on target paper size
		//galleryRowsPerPage: 0,

		// String: HTML template selected for view (Default, Right, Basic) if explicit one not defined for view
		//galleryTemplate: null,

		// String: print headers once (""), per page ("Page"), or per group ("Group")
		//groupHeaderStyle: "",

		// Number: desired width of group header (optional)
		//groupHeaderWidth: 0,

		// Number: maximum blocks in row per column when grouping
		//groupItemsPerRow: 0,

		// Boolean: hide placeholder if there is no result
		// hidePlaceholder: null,

		// DOMNode: element containing view message, usually including number of results
		messageNode: null,

		// DOMNode: element indicating if there are more results to display
		moreNode: null,

		// DOMNode: element containing gallery content that will host CSS based on view options
		optionsNode: null,

		// DOMNode: element containing placeholder content that will host CSS based on view options
		placeholderNode: null,

		// Number: percent to scale all text by, between minimum font scale and 100
		printFontScale: 100,

		// DOMNode: table element when grouping
		//plotNode: null,

		/** @property {HTMLElement} scrollBottomNode - make visible to show box shadow at bottom of view when scrolled up */
		scrollBottomNode: null,

		/** @property {HTMLElement} scrollTopNode - make visible to show box shadow at top of view when scrolled down */
		scrollTopNode: null,

		/** @property {string} _effectiveImageSize - effective image size to use based on settings */
		_effectiveImageSize: null,

		// Spec: specifications for row and column group attributes
		//_groupColSpec: null,
		//_groupRowSpec: null,

		// Store: Values store for row and column groups
		//_groupColValues: null,
		//_groupRowValues: null,

		// String[]: keys on elements that require aligning
		//_keysToAlign: null,

		// Action: action to expand/collapse plot cell
		//_plotAction: null,

		/** @property {number} _plotFirstColumnWidth - store first column width of plot table so it stays consistent as you interact with it */
		//_plotFirstColumnWidth: 0,

		// Number: number of plot columns and rows
		//_nPlotCols: 0,
		//_nPlotRows: 0,

		postCreate: function() {
			// summary: if view part of form, then enable selection of gallery blocks
			this.inherited(arguments);

			// listen for changes to view selections to invoke select action when in form
			if (this.allowsSelections()) {
				this.enableRefNodeSelection(this.getContentRoot());
				this.defView.m_formData.addSelectListener((ctx, url, bOn, bReplaced) => this.onSelect(ctx, url, bOn, bReplaced));
			}

			// allow setting page size to All in custom view for views enabled for grouping;
			// if no grouping, then disallow selecting All in view
			if (this.defView.isPlotOptionEnabled()) {
				this.set("querySizeStoreForCustomView", PageSize);
			} else {
				this.set("querySizeStore", PageSizeWithoutAll);
			}

			// add shadow when scroll
			const {scrollNode, scrollBottomNode, scrollTopNode} = this;

			html.setVisible(scrollBottomNode, false);
			html.setVisible(scrollTopNode, false);

			if (scrollNode) {
				this.own(on(scrollNode, "scroll", () => this._updateScrollShadows()));
			}
		},

		/**
		 * @override
		 * Resize when view is done loading
		 */
		startup() {
			const dfd = this.inherited(arguments);
			dfd?.then(() => this.resize());
			return dfd;
		},

		canSort: function() {
			// summary: view must allow custom attributes for sorting to work
			return this.bAllowDataPoints && this.inherited(arguments);
		},

		/**
		 * @override
		 * View needs to be redrawn when forced to be read-only
		 */
		forceReadOnly() {
			this.inherited(arguments);
			this.redraw();
		},

		getAction: function(/*String*/idAction, /*DOMNode*/element, /*Object*/params) {
			// summary: look for action on relationship; otherwise, do default view behavior
			return this.relRoot.getAction(idAction) || this.inherited(arguments);
		},

		getImage: function() {
			// summary: return image definition if one
			return this.defView.defsByKey.image;
		},

		/**
		* Return the image size based on view
		* @return {string} -  the image size
		*/
		getDefaultImageSize: function() {
			return this.bPopup ? reflection.IMAGE_SIZE_SMALL : this.defView.defaultImageSize;
		},

		/**
		 * @override
		 * Return image size based on view settings
		 */
		getEffectiveImageSize() {
			return this._effectiveImageSize || this.imageSize;
		},

		getGroupHeaderStyleStore: function() {
			// summary: return store containing options for groupHeaderStyle
			_groupHeaderStyleStore = _groupHeaderStyleStore || new Memory({
				data: [
					{id: "", name: csiPrefs.optionResource("PlotGroupHeadersOnce")},
					{id: constants.GALLERY_HEADERS_PER_PAGE, name: csiPrefs.optionResource("PlotGroupHeadersPerPage")},
					{id: constants.GALLERY_HEADERS_PER_GROUP, name: csiPrefs.optionResource("PlotGroupHeadersPerGroup")}
				]
			});

			return _groupHeaderStyleStore;
		},

		/**
		 * Return spec for main image
		 * @return {Spec | undefined}
		 */
		getImageSpec() {
			const defImage = this.getImage();
			if (defImage) {
				return this.specBuilder.getSpecForHeading(defImage);
			}
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			const params = {};

			if (this.plotNode) {
				// strategy for grouped gallery views is to switch to expandAllGroups mode, and pass store
				// as property containing only those nodes that are currently displayed in view; use jQuery
				// to get only those refNodes that are currently visible (containing group is not collapsed)
				const refNodes = $("." + csiGallery.CSS_BLOCK, this.plotNode).filter(":visible");
				const nodes = refNodes.map((idx, domNode) => this.getQueryResultByDomNode(domNode).getNode());
				if (this.groupSettings) {
					this.groupSettings.expand1 = true;
				}

				params.store = new Nodes({
					cachingStore: this.cacheView,
					data: nodes
				});
			} else {
				params.query = this.query;
			}

			return params;
		},

		getRefNodeById: function(/*String*/id) {
			// summary: return DOMNode for given QueryResult id
			return html.queryDom([".", csiGallery.CSS_BLOCK, html.getDataAttributeSelector(html.DATA_RESULT, id)], this.getContentRoot() || this.domNode, true);
		},

		getRefNodeByUrl: function(/*String*/url) {
			// summary: return DOMNode associated with url to support selection
			return html.queryDom([".", csiGallery.CSS_BLOCK, html.getDataAttributeSelector(html.DATA_URL, url)], this.getContentRoot() || this.domNode, true);
		},

		getRefNodes: function() {
			// summary: return all blocks in view
			return csiGallery.getBlocks(this.getContentRoot() || this.domNode);
		},

		getSpecValues: function(/*String*/id, /*Object*/storeOptions) {
			// summary: override to return csi/store/Values for Spec with given id
			storeOptions.ctx = this.getContext(csi.EMPTY_URL);
			return this.inherited(arguments);
		},

		getTemplateStore: function() {
			// summary: return store for templates if template is not fixed
			if (this.defView.templatePath) {
				return null;
			}

			_templateStore = _templateStore || new Memory({
				data: [
					{id: constants.PREFERENCE_DEFAULT, name: locale.resource("GalleryTemplateBelow"), file: "Html/GalleryBelow.html", basic: false, attrEqualsImageWidth: true},
					{id: constants.GALLERY_TEMPLATE_RIGHT, name: locale.resource("GalleryTemplateRight"), file: "Html/GalleryRight.html", basic: false, attrEqualsImageWidth: false},
					{id: constants.GALLERY_TEMPLATE_BASIC, name: locale.resource("GalleryTemplateBasic"), file: "Html/GalleryBasic.html", basic: true, attrEqualsImageWidth: true}
				]
			});

			return _templateStore;
		},

		getDefaultImageDimension() {
			return this.isCustomImage() ? IMAGE_DIMENSION_MIN : 0;
		},

		/**
		* Return true if view contains multiple child views
		* @return {boolean}
		*/
		isStackedView: function() {
			return false;
		},

		isCustomImage() {
			return this.imageSize === IMAGE_SIZE_CUSTOM;
		},

		/**
		 * @override
		 * Set FilterRemember Custom view option value through api
		 */
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);
			cv.setValue("filterRemember", api.getDefaultRememberAdHocFilter());

			const imageSpec = this.getImageSpec();
			if (!imageSpec) {
				cv.removeCustomOption("galleryImageHeight");
				cv.removeCustomOption("galleryImageLabel");
				cv.removeCustomOption("galleryImageWidth");
				cv.removeCustomOption("galleryRowsPerPage");
			} else if (!imageSpec.rc.hasImageLabels) {
				cv.removeCustomOption("galleryImageLabel");
			}

			const templateStore = this.getTemplateStore();
			if (!templateStore) {
				cv.removeCustomOption("galleryAttributeWidth");
				cv.removeCustomOption("galleryTemplate");
				cv.removeCustomOption("groupItemsPerRow");
			}

			if (!this.defView.isPlotOptionEnabled()) {
				cv.removeCustomOption("groupHeaderStyle");
				cv.removeCustomOption("groupHeaderWidth");
				cv.removeCustomOption("groupItemsPerRow");
				cv.removeCustomOption("groupSettings");
			}
			else if (!this.groupSettings) {
				// set groupSettings for default view
				this.set("groupSettings", {});
			}

			cv.setValue("sortSettings", this.loadDefaultSortSettings());
		},

		onContext: function(/*Context*/ctx) {
			// summary: extension point to affect view context
			if (this.allowsSelections()) {
				ctx.bReserveClick = true;
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Groups and matrices are not currently supported by gallery views
		 */
		onCustomViewAttributeOptions(options) {
			options.fixed = !this.bAllowDataPoints;
			options.noGroupSupport = true;
			options.noMatrixSupport = true;
			this.inherited(arguments);
		},

		onViewPreferences: function() {
			// summary: post-process view settings after loading custom view
			this.inherited(arguments);

			// previously groupItemsPerRow was stored as string, so convert to number
			this.set("groupItemsPerRow", Number(this.groupItemsPerRow) || 0);

			// grouped gallery views are always fully expanded when printing (covers non-ad-hoc PDFs)
			if (state.get("print")) {
				this.set("expandAllGroups", true);
			}
		},

		onViewStart: function(/*Deferred[]*/dfds) {
			// summary: initialize specs for grouping if needed
			if (this.defView.isPlotOptionEnabled()) {
				const {key1: columnGroupAttribute, key2: rowGroupAttribute, expand1} = this.groupSettings;
				this.expandAllGroups = expand1;

				this._groupColSpec = columnGroupAttribute ? this.getHeadingSpec(columnGroupAttribute) : null;
				this._groupRowSpec = rowGroupAttribute ? this.getHeadingSpec(rowGroupAttribute) : null;
				this.bPlot = !!this._groupColSpec || !!this._groupRowSpec;

				this.set("querySizeDisabled", this.bPlot);
				this.set("refreshOnSuspend", true);
			}
		},

		onViewToolbar: function(/*Toolbar*/tb) {
			// summary: revert back to base csi.view.Widget
		},

		addBlocks: function(/*Node[]*/nodes, /*DOMNode?*/refNodeNext, /*Boolean*/bNew) {
			// summary: instantiate HTML template for each node and insert into DOM
			var actions = this._getBlockActions();
			var contentNode = this.getContentRoot();
			var ctx = this.getContext();
			var refNodes = [];

			// all dependency paths should have been queried as part of request for main results (when not new), so do not force new query when
			// pushing path on the context; this will fix individual queries for nodes to which the user does not have access
			if (!bNew) {
				ctx.bPathsQueried = true;
			}

			ctx.preRollup();

			ctx.forEach(nodes, function(ctx) {
				var refNode = this._toHtmlResult(ctx, contentNode, null, refNodeNext, actions, bNew);
				refNodes.push(refNode);
			}, this);

			ctx.postRollup();

			if (bNew) {
				this._onChangeResults();
			}

			return waitForImagesToLoad().then(() => refNodes);
		},

		deleteBlock: function(/*DOMNode*/refNode) {
			// summary: delete item from store and view - only corner case is Comments view where delete action is used to delete a reply that is not a top-level result
			var qr = this.getQueryResultByDomNode(refNode);
			if (qr) {
				html.destroyElement(refNode);
				this._removeQueryResult(qr, true);
				this._onChangeResults();
			}
		},

		hasContent: function() {
			// summary: return true if view is showing content to print/export
			return this.queryDisplayCount !== 0;
		},

		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: actions on view may cause resize
			if (this.inherited(arguments)) {
				this.resize();
				return true;
			}

			return false;
		},

		queryMore: function() {
			// summary: query more results for view
			var queryOptions = this.getQueryResultOptions(null, true);

			// don't use display:none as that will make the view jump
			html.setVisibility(this.moreNode, false);

			return this.when(this._query(null, queryOptions),
				results => this.when(this._buildViewResults(results, false), lang.hitch(this, this._buildViewDone))
			);
		},

		resetForm: function() {
			// summary: reset selections
			var view = this._getFormDataWidget();

			if (view.defView.m_formData) {
				view.defView.m_formData.resetSelections(view.getContext());
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Toggle table suspension by hiding/showing body and disabling/enabling view queries
		 */
		suspendView(suspended) {
			this.set("suspended", suspended);
			return suspended ? this.resize() : this.redrawData();
		},

		validateForm: function(/*Object*/errorParams) {
			// summary: if selection is required and none exists, then show error
			var view = this._getFormDataWidget();
			var fd = view ? view.defView.m_formData : null;
			var error = fd ? fd.getValidationError() : null;
			if (error) {
				errorParams.suffix = error;
				return false;
			}

			return true;
		},

		/**
		 * @override
		 * Render content to view, querying information as needed
		 */
		_buildView() {
			// first, cleanup view content
			html.destroyElement(this.plotNode);
			this.plotNode = null;
			this._groupColValues = null;
			this._groupRowValues = null;
			this._resetQueryResults();
			this.set("queryTotalCount", null);
			this._createQueryLevels();

			if (this.isSuspended()) {
				// handle view suspend mode
				if (this.showCountIfSuspended && !this.suspendedUntilScrolledIntoView) {
					// query for number of results
					var qr = this.getQueryResult();
					var queryOptions = {
						requestParameters: {
							"Operation": qr.getStore().requestOperationCount,
							"Qry.Limit.Filter": constants.QUERY_COUNT_LIMIT
						}
					};
					this.when(this._query(qr, queryOptions), () => this._buildViewDone());
				} else {
					// don't need to query for count or results, so just need to finish up
					this._buildViewDone();
				}

				return;
			}

			// force querySize to 0 if either group attribute is set and initialize grouping specs
			if (this.bPlot) {
				this.set("querySize", 0);
			}

			// update template to use for view
			var templateStore = this.getTemplateStore();
			var template = templateStore && templateStore.get(this.galleryTemplate || constants.PREFERENCE_DEFAULT);
			if (template) {
				this.set("bImageAboveAttrs", template.attrEqualsImageWidth);
				this.setTemplate(template.file);
			}

			// update image size based on other view settings if necessary
			const defaultImageDimension = this.getDefaultImageDimension();
			var gh = this.galleryImageHeight || defaultImageDimension;
			var gw = this.galleryImageWidth || defaultImageDimension;
			var imageSize = this.imageSize;
			var imageSizeClass;

			if (state.get("print")) {
				// add properties needed for splitting gallery view content
				html.setDataAttribute(this.domNode, html.DATA_GALLERY_IMAGE_ON_TOP, this.bImageAboveAttrs);
				html.setDataAttribute(this.domNode, html.DATA_GALLERY_RESIZE_ATTRIBUTES, this.bImageAboveAttrs && !this.galleryAttributeWidth);
				html.setDataAttribute(this.domNode, html.DATA_GALLERY_ROWS_PER_PAGE, this.galleryRowsPerPage);

				// if we may need to split the view horizontally due to column grouping, then we need to start on fresh page;
				// if also specifying the number of rows per page, then starting on a fresh page is also best.
				const columnGroupAttribute = this.groupSettings?.key1;
				if (columnGroupAttribute || this.galleryRowsPerPage) {
					html.setDataAttribute(this.domNode, html.PRINT_BREAK, true);
				}

				// determine image size based on rows-per-page setting
				if (this.galleryRowsPerPage && template) {
					var printSize = getImagePixelSizeByRowsPerPage(this.galleryRowsPerPage);
					gw = Math.max(gw, printSize);
					gh = Math.max(gh, printSize);
				}
			}

			if (gh || gw) {
				// if width specified, then derive image size based on image height and width
				imageSize = getImageSizeBySize(gh, gw, this.bAllowOriginal);
			}

			this._effectiveImageSize = imageSize;

			if (this.optionsNode) {
				if (!this.galleryImageHeight && !this.galleryImageWidth) {
					// apply CSS based on custom view options for default image size
					var imageSizeValue = xml.enumGetText(imageSize);
					if (imageSizeValue) {
						imageSizeClass = "galleryImage" + imageSizeValue;
					}
				}

				this.optionsNode.className = imageSizeClass || "";
			}

			// set image label for image - do only for container attributes (i.e. Images) rather than single ref to image
			var defImage = this.getImage();
			if (defImage && (defImage.m_index != null)) {
				defImage.m_index = this.galleryImageLabel || reflection.DEFAULT_IMAGE_LABEL;
			}

			// start rendering view
			if (this.getViewNode()) {
				var dfds = [];
				var bQuery;

				if (!this.bPlot || this.expandAllGroups) {
					dfds.push(this._query());
					bQuery = true;
				}

				if (this.contentNode) {
					dfds.push(this.contentNode.onLoadDeferred);
				}

				this.when(all(dfds),
					lang.hitch(this, function(results) {
						// first set of results will be those of the query
						this.when(this._buildViewResults(bQuery ? results[0] : null, true), lang.hitch(this, this._buildViewDone));
					})
				);
			} else {
				this._setMainQueryLevelTotal(0);
				this._buildViewDone();
			}
		},

		_buildViewResults: function(/*QueryResults*/results, /*Boolean*/bRefresh) {
			// summary: render view after template and data loaded
			var self = this;
			var ctx = this.getContext(csi.EMPTY_URL);
			var dfd;

			// remove actions node if no actions
			if (this.blockNode && !bRefresh) {
				var actionNode = this._getBlockActionNode(this.blockNode);
				if (actionNode && !this._getBlockActions()) {
					domConstruct.destroy(actionNode);
				}
			}

			if (this.bPlot) {
				// build table for grouping
				if (this.expandAllGroups) {
					domClass.replace(this.domNode, "galleryViewPlotExpanded", "galleryViewPlotCollapsed");
					dfd = this._buildHtmlPlotExpandAll(results);
				} else {
					domClass.replace(this.domNode, "galleryViewPlotCollapsed", "galleryViewPlotExpanded");
					dfd = this._buildHtmlPlotCollapsed();
				}

				// if header width specified, then fix header width and height; if not specified, then this will only be done when printing view
				if (this.groupHeaderWidth) {
					this.when(dfd, function() {
						csiGallery.fixGroupHeaders(self.plotNode.firstChild, self.groupHeaderWidth);
					});
				}

				return dfd;
			}

			// if in popup, make sure to only show nodes that can be selected
			if (this.allowsSelections()) {
				results = results.filter((node) => ctx.fd.canSelectNode(ctx.setNode(node)));
			}

			// render results in groups of 20 to avoid browser hang
			var blocks = [];
			var groupDfds = [];
			var err;

			dfd = new Deferred();

			csi.forEachWithTimeout(
				results,
				20,
				function(group) {
					if (!err && this.isValidView()) {
						try {
							var groupDfd = this.addBlocks(group);
							if (groupDfd) {
								groupDfds.push(groupDfd.then(function(refNodes) {
									blocks = blocks.concat(refNodes);
								}));
							}
						} catch (ex) {
							err = ex;
						}
					}
				},
				null,
				function() {
					if (err) {
						dfd.reject(err);
					} else {
						this.when(all(groupDfds), function() {
							dfd.resolve(blocks);
						});
					}
				},
				this
			);

			return dfd;
		},

		_buildViewDone: function() {
			// summary: done populating content, so fade in and finish
			if (this.plotNode) {
				this.getContentRoot().appendChild(this.plotNode);
			}

			this._processFade();
			this._postView();
		},

		/**
		 * @override
		 * Migrate from flat list of attribute keys to new grouped structure
		 */
		_migrateAndValidateCustomViewValues(version, values) {
			const {galleryImageLabel, galleryTemplate, galleryImageHeight, galleryImageWidth} = values;
			const imageSpec = this.getImageSpec();
			const imageOwnerClass = imageSpec?.rc;

			// validate that chosen image label is still available
			if (galleryImageLabel && (!imageOwnerClass || !isImageLabelValid(imageOwnerClass, galleryImageLabel))) {
				values.galleryImageLabel = "";
			}

			// set gallery attribute width to gallery image width if gallery template is not attribute right
			if (galleryTemplate !== constants.GALLERY_TEMPLATE_RIGHT) {
				values.galleryAttributeWidth = galleryImageWidth;
			}

			// ensure image size is set to custom if gallery has custom image sizes
			if (version < CustomViewVersion.V791) {
				if (galleryImageHeight || galleryImageWidth) {
					values.imageSize = IMAGE_SIZE_CUSTOM;
				}
			}

			this.inherited(arguments);
		},

		/**
		 * Return true if more node should be displayedUpdate display of More node based on current conditions
		 */
		_shouldDisplayMoreNode() {
			return this.getViewNode() && !this.bPlot && !!this.getQueryResult(null, true)?.hasMoreChildren();
		},

		/**
		 * Display or hide the no results placeholder based on results
		 */
		_togglePlaceholder() {
			// do not render placeholder if the table is in print preview or explicitly hidden
			const {
				bPlot,
				hidePlaceholder,
				messageNode,
				moreNode,
				placeholderNode,
				scrollNode,
			} = this;

			if (state.get("print") || hidePlaceholder || !messageNode) {
				return;
			}

			let galleryBottomHeight = 49;
			let displayResultsCount = false;
			let description;
			let showActions = false;
			let title;
			let type;

			if (this.suspendedUntilScrolledIntoView) {
				type = this._getNoResultType();
				title = locale.resource("LoadingEllipsis");
				description = "";
			} else if (this.isSuspended()) {
				// handle suspend mode
				type = "Suspend";

				if (this.showCountIfSuspended) {
					galleryBottomHeight = 65;
					displayResultsCount = true;
				}
			} else if (!this.queryDisplayCount && !this._groupColValues && !this._groupRowValues) {
				// handle no result
				type = this._getNoResultType();
				showActions = true;
			}

			// hide gallery content if showing placeholder; when transitioning from a placeholder back to gallery content,
			// we want to show the placeholder until the content is ready to show; so only unhide the content when the
			// placeholder is finally removed
			scrollNode.classList.toggle("csi-gallery-hide-content", !!type);

			// destroy existing placeholder
			placeholderNode?.destroy();
			this.placeholderNode = null;

			// display more button if necessary; restore visibility that may have been hidden when More button is pressed
			if (moreNode) {
				html.setVisibility(moreNode, true);
				html.setVisible(moreNode, !type && !bPlot && !!this.getQueryResult(null, true)?.hasMoreChildren());
			}

			if (!type) {
				return;
			}

			var MINIMUM_HEIGHT_FOR_IMAGE = 370;
			var GALLERY_PLACEHOLDER_DEFAULT_HEIGHT = 170;
			var height = GALLERY_PLACEHOLDER_DEFAULT_HEIGHT;

			if (!this.viewParent || !this.viewParent.isStackedView()) {
				height = html.getAvailableHeight(this.containerNode) - galleryBottomHeight;
			}

			var displayImage = (height >= MINIMUM_HEIGHT_FOR_IMAGE);
			var resultNodeType = this.getResultNodeType();

			// parameters for placeholder resource are target type of view and root type of view
			var params = [
				locale.type(resultNodeType),
				locale.type(this.getViewNodeType())
			];

			if (title == null) {
				title = this._getTitle(type, params);
			}

			if (description == null) {
				description = this._getDescription(type, params);
			}

			var additionalText = locale.resourceIfExists("ViewPlaceholderAdditional" + resultNodeType) || "";

			// create placeholder
			this.placeholderNode = new GalleryPlaceholder({
				type,
				height,
				titleText: title,
				description,
				additionalText,
				bImage: displayImage,
				showActions,
				widget: this
			});

			this.placeholderNode.placeAt(messageNode, "before");
			html.setVisible(messageNode, displayResultsCount);
		},

		_buildHtmlPlotCollapsed: function() {
			// summary: query for group values and build table headers for each combination of values
			var nodesStore = this.get("store");
			var queryObj = this.get("queryForServer");
			var rspec = this._groupRowSpec;
			var cspec = this._groupColSpec;
			var store;

			var valuesStoreOptions = {
				ctx: this.getContext(csi.EMPTY_URL)
			};

			if (rspec && cspec) {
				store = nodesStore.getValuePairsStore(rspec, cspec, valuesStoreOptions);
			} else {
				store = nodesStore.getValuesStore(rspec || cspec, valuesStoreOptions);
			}

			return this.when(store.query(queryObj), lang.hitch(this, function(results) {
				// notify view or results to main view query
				this._setMainQueryLevelTotal(store.getResultTotal());

				if (results && results.length) {
					// caclulate row/column Values stores
					if (rspec && cspec) {
						this._groupRowValues = new ValuesFromPairs({
							_store: store,  // FIX - rename to cachingStore
							spec: store.spec1,
							valuesStoreOptions: valuesStoreOptions
						});
						this._groupColValues = new ValuesFromPairs({
							_store: store,  // FIX - rename to cachingStore
							spec: store.spec2,
							valuesStoreOptions: valuesStoreOptions
						});
					} else if (rspec) {
						// this store is filled with values, so disable from going to server again
						this._groupRowValues = store;
						store.requestModule = null;
					} else {
						this._groupColValues = store;
						store.requestModule = null;
					}

					// build table headers based on Values
					this._buildHtmlPlotTable();

					// apply counts to headers
					var cstore = this._groupColValues;
					var rstore = this._groupRowValues;
					var idIndex = (rstore || cstore).indexProperty;
					var idRowValue = (rstore && cstore) ? store.value1Property : store.idProperty;
					var idColumnValue = (rstore && cstore) ? store.value2Property : store.idProperty;
					var idCount = store.countProperty;

					results.forEach((item) => {
						var count = item[idCount];
						if (count) {
							var row = rstore ? rstore.get(item[idRowValue])[idIndex] : 0;
							var column = cstore ? cstore.get(item[idColumnValue])[idIndex] : 0;
							this._setPlotCellCount(this._getGroupCell(row, column), count);
						}
					});
				}

				return [];
			}));
		},

		_buildHtmlPlotExpandAll: function(/*QueryResults*/results) {
			// summary: plot nodes in table according to row and column attributes
			if (!results || !results.length) {
				return null;
			}

			var ctx = this.getContext(csi.EMPTY_URL);
			ctx.preRollup();

			// extract Values store for rows and columns from nodes
			if (this._groupColSpec) {
				this._groupColValues = Values.createFromNodes(results, {
					ctx: ctx,
					spec: this._groupColSpec
				});
			}

			if (this._groupRowSpec) {
				this._groupRowValues = Values.createFromNodes(results, {
					ctx: ctx,
					spec: this._groupRowSpec
				});
			}

			// build structure for plot view and render nodes into appropriate cells
			this._buildHtmlPlotTable();

			return this.when(this._plotNodes(results, ctx), function() {
				ctx.postRollup();
			});
		},

		/**
		 * Return array of group values from given store; if the view is sorted by the attribute,
		 * then reverse the order of the values
		 * @param {Values} store 
		 * @param {Spec} spec 
		 * @return {Object[]|null}
		 */
		_queryGroupValues: function(store, spec) {
			if (!spec) {
				return null;
			}

			const {queryForServer, sortSettings} = this;
			const sort = sortSettings?.find(({key}) => key === spec.uniqueId);
			let values = store.query(queryForServer);

			if (sort?.descending) {
				const {indexProperty} = store;
				values = values.reverse();
				values.forEach((item, i) => {
					item[indexProperty] = i;
				});
			}

			return values;
		},

		_buildHtmlPlotTable: function() {
			// summary: make table according to row and column values
			var ctx = this.getContext(csi.EMPTY_URL);
			var cspec = this._groupColSpec;
			var rspec = this._groupRowSpec;
			var cstore = this._groupColValues;
			var rstore = this._groupRowValues;
			var cvalues = this._queryGroupValues(cstore, cspec);
			var rvalues = this._queryGroupValues(rstore, rspec);
			var bQueryMax = this.doesQueryTotalExceedMax();
			var expandAction = !this.expandAllGroups && this._plotAction;

			this._nPlotCols = cvalues ? cvalues.length : 1;
			this._nPlotRows = rvalues ? rvalues.length : 1;
			this._plotFirstColumnWidth = 0;

			// build table with rows and columns
			var plotNode = this.plotNode = domConstruct.create("table", {
				"class": "csi-gallery-table"
			});

			// annotate DOM with properties necessary for splitting content
			if (state.get("print")) {
				html.setDataAttribute(plotNode, html.DATA_GALLERY_GROUP_ITEMS_PER_ROW, this.groupItemsPerRow);
				html.setDataAttribute(plotNode, html.DATA_GALLERY_GROUP_STYLE, this.groupHeaderStyle);
				html.setDataAttribute(plotNode, html.DATA_GALLERY_GROUP_WIDTH, this.groupHeaderWidth);
			}

			// build column headings
			var thead = domConstruct.create("thead", null, plotNode);
			var tr = domConstruct.create("tr", null, thead);
			var tbody = domConstruct.create("tbody", null, plotNode);
			var cell;
			var r = -1;
			var c = -1;

			var createCell = function(css) {
				var tagName = (r == -1 || c == -1) ? "th" : "td";
				var cell = html.create(tagName, {"class": css || ""}, tr);
				html.setDataAttribute(cell, html.DATA_GALLERY_GROUP_COLUMN, c);
				html.setDataAttribute(cell, html.DATA_GALLERY_GROUP_ROW, r);
				return cell;
			};

			var createTitle = function(domNode, rowName, columnName) {
				// summary: store row and column information on cell and populate with action to expand and group title
				var title = _getPlotCellTitle(rowName, columnName);

				if (expandAction) {
					expandAction.toHtmlWithAccess(ctx, domNode);

					// hide expand collapse button if items exceed maximum limit
					if (domNode.firstChild && bQueryMax && (r == -1 || c == -1)) {
						html.setVisible(domNode.firstChild, false);
					}
				}

				html.create("span", {
					"class": "dijitReset dijitInline",
					style: "display: inline",
					innerText: title
				}, domNode);
			};

			// 1st cell: row and column attributes names, expand all / collapse all button
			cell = createCell("csi-gallery-table-group");
			createTitle(cell, rspec && rspec.getText(), cspec && cspec.getText());

			if (cvalues) {
				// create column headers
				for (c = 0; c < this._nPlotCols; ++c) {
					cell = createCell("csi-gallery-table-header plotColumn" + c);
					createTitle(cell, null, cvalues[c][cstore.labelProperty]);
				}
			} else {
				// no column headers, only rows are given
				domConstruct.create("th", {"class": "csi-gallery-table-header"}, tr);
			}

			// create row headers
			var header, rname, cname;

			for (r = 0; r < this._nPlotRows; ++r) {
				c = -1;
				tr = domConstruct.create("tr", {"class": "plotRow" + r}, tbody);
				cell = createCell("csi-gallery-table-header");

				if (rvalues) {
					rname = rvalues[r][rstore.labelProperty];
					createTitle(cell, rname, null);
				}

				for (c = 0; c < this._nPlotCols; ++c) {
					cell = createCell("csi-gallery-table-cell plotColumn" + c);
					header = domConstruct.create("div", {"class": "galleryViewPlotHeader", style: "display: none"}, cell);

					if (cvalues) {
						cname = cvalues[c][cstore.labelProperty];
					}

					createTitle(header, rname, cname);
					domConstruct.create("span", {"class": "dijitReset dijitInline galleryViewPlotCount"}, header);
					domConstruct.create("div", {"class": "galleryViewPlotContent"}, cell);
				}
			}

			domStyle.set(plotNode, "display", "");

			// sync frozen column and row scroll bars with tbody scroll bar
			this.own(on(tbody, "scroll", () => this._updateFrozenScrolling()));
		},

		_addBlockStyling: function(/*DOMNode*/refNode) {
			// summary: add CSS to node indicating it is refNode in view
			domClass.add(refNode, csiGallery.CSS_BLOCK);
		},

		_removeBlockStyling: function(/*DOMNode*/refNode) {
			// summary: clear CSS from node indicating it is refNode in view
			domClass.remove(refNode, csiGallery.CSS_BLOCK);
		},

		_getBlockActionNode: function(/*DOMNode*/refNode) {
			// summary: return action node for given block
			return html.queryDom([html.getDataAttributeSelector(html.DATA_TEMPLATE_ACTIONS, "1")], refNode, true);
		},

		_getBlockActions: function() {
			// summary: return actions to render per block
			return this.getMainQueryLevel().actions;
		},

		/**
		 * Return no result placeholder description
		 * @param {string} type - type of placeholder
		 * @param {Object} params - parameters
		 * @return {string}
		 */
		_getDescription: function(type, params) {
			if (!this.canFilter()) {
				return locale.resource("ViewPlaceholderDescriptionNoResultWithParameter", params);
			} else {
				return type ? locale.resource("ViewPlaceholderDescription" + type, params) : "";
			}
		},

		/**
		 * Return no result placeholder type
		 * @return {string}
		 */
		_getNoResultType: function() {
			return "NoResult";
		},

		/**
		 * Return placeholder title
		 * @param {string} type - type of placeholder
		 * @param {Object} params - parameters
		 * @return {string}
		 */
		_getTitle: function(type, params) {
			return locale.resource("ViewPlaceholderTitle" + type, params);
		},

		_hasToolbar: function() {
			// summary: revert back to base csi.view.Widget
			return HtmlWidget.superclass._hasToolbar.call(this);
		},

		_onClickMore: function() {
			// summary: enter debug mode
			csiAction.invoke(this, this.domNode, this.moreAction);
		},

		_onCreateQueryLevels: function(/*QueryLevel[]*/queryLevels) {
			// summary: finish configuration of query levels
			const {
				attributeKeys,
				attributeSpecs,
				defView,
				galleryTemplate,
				sortSettings,
				specBuilder,
				_groupColSpec,
				_groupRowSpec
			} = this;

			// calculate dependency paths for headings
			const paths = [];

			// if not using basic template, then add all paths from attributes in custom view (non-fixed)
			if (galleryTemplate !== constants.GALLERY_TEMPLATE_BASIC) {
				paths.push(...collectSpecDependencyPaths(attributeSpecs));
			}

			// add paths for row and column grouping attributes
			paths.push(_groupColSpec?.getStandardQueryPath() || "");
			paths.push(_groupRowSpec?.getStandardQueryPath() || "");

			// collect paths from other view definitions (fixed headings, actions, rules, etc.)
			_.each(defView.m_defs, (obj) => {
				if (obj.key !== html.DATA_TEMPLATE_KEY_REPEAT) {
					const p = obj.getQueryPath?.() ?? obj.m_path;
					if (p) {
						paths.push(p);
					}
				}
			});

			queryLevels[1].addDependencyPaths(paths);

			// create store of specs available for filtering
			// NOTE: this must be done after setting dependency paths as creation of the main store
			// is triggered by setting the spec store
			const {getSpecForHeading} = specBuilder;
			const nameHeading = defView.defsByKey.name;
			const nameSpec = nameHeading && getSpecForHeading(nameHeading);
			const specs = new Specs();
			let specsArray = [];

			// if name is empty, we still want it to take up consistent amount of space in view
			if (nameHeading) {
				nameHeading.bPlaceholder = true;
			}

			const addQuerySpec = (spec) => {
				if (spec?.queryKey) {
					specsArray.push(spec);
				}
			};

			defView.getFixedHeadings()?.forEach((h) => {
				if (h === nameHeading) {
					specs.add(nameSpec);
				} else {
					addQuerySpec(getSpecForHeading(h));
				}
			});

			// add attribute specs, including hidden ones (which is why we don't use attributeSpecs)
			attributeKeys?.forEach((key) => {
				addQuerySpec(this.getHeadingSpec(key));
			});

			// add grouping specs
			addQuerySpec(_groupColSpec);
			addQuerySpec(_groupRowSpec);

			// add sort specs
			sortSettings?.forEach(({key}) => {
				if (key !== nameSpec?.uniqueId) {
					addQuerySpec(this.getHeadingSpec(key));
				}
			});

			specsArray = _.uniqBy(specsArray, ({queryKey}) => queryKey);
			specsArray = _.sortBy(specsArray, ({name}) => name);
			specsArray.forEach((s) => {
				specs.add(s);
			});

			this.set("querySpecStore", specs.getQueryStore(false));
			this.setQueryDefaults();
		},

		_onLoadTemplate: function() {
			// summary: when template loaded, hide it so that it is not shown until populated with results
			if (!this.htmlTemplate) return;

			var rootNode = this.getContentRoot();

			// do not use "em" units when printing as the font size scaling (printFontScale) only applies to the attributes section
			// of the card and should only make the text smaller, not the whole section smaller
			var dimObj = html.addStyleUnits(rootNode, {
				imageHeight: this.galleryImageHeight || "auto",
				imageWidth: this.galleryImageWidth || "auto",
				attrWidth: this.galleryAttributeWidth
			});

			// store reference to template DOM
			this.blockNode = rootNode.removeChild(rootNode.firstChild);

			this._keysToAlign = html.getDataAttributeValues(html.DATA_TEMPLATE_ALIGN, this.blockNode);

			// if aligning entire block, then add "true" as key to end - this must be last key to align
			var a = html.getDataAttribute(this.blockNode, html.DATA_TEMPLATE_ALIGN);
			if (a != null) {
				this._keysToAlign.push(csiGallery.BLOCK_ALIGN_KEY);
			}

			// apply image and attribute styling
			var imageNode = this.blockNode.querySelector(".csiGalleryImage");
			if (imageNode) {
				if (!xml.enumGetText(this.imageSize)) {
					// remove image key if no image size specified
					html.orphan(imageNode);
				} else if (this.galleryImageHeight || this.galleryImageWidth) {
					// apply styles to image
					html.setCSSVariable(imageNode, "GalleryImageVariableHeight", dimObj.imageHeight, true);
					html.setCSSVariable(imageNode, "GalleryImageVariableWidth", dimObj.imageWidth, true);
					imageNode.classList.add("csi-gallery-image-variable");

					// if styling image height, then no need to align them
					if (this.galleryImageHeight) {
						this._keysToAlign = _.without(this._keysToAlign, csiGallery.IMAGE_ALIGN_KEY);
					}
				}
			}

			if (this.galleryAttributeWidth) {
				query(".csiGalleryProperties", this.blockNode).style(html.WIDTH, dimObj.attrWidth);
			} else {
				domClass.add(this.blockNode, "csi-gallery-variable-width");
			}

			// determine if template allow custom data points
			if (this.defView.templatePath && !query(html.getDataAttributeSelector(html.DATA_TEMPLATE_KEY, "\\*", true), this.blockNode).length) {
				this.bAllowDataPoints = false;
			}

			if (state.get("print")) {
				if (this.printFontScale) {
					// We'll apply the scale user has selected on CV here. So when the template gets copied for each gallery card, we'll have these CSS rules on them.
					var areasToChangeFont = $(this.blockNode).find(".csiGalleryProperties, .csiGalleryPropertiesHeader .name");
					areasToChangeFont.css("font-size", this.printFontScale + "%");
				}

				if (this._keysToAlign) {
					html.setDataAttribute(this.domNode, html.DATA_GALLERY_ALIGN_KEYS, this._keysToAlign.join());
				}
			}

			// when template loaded, need to also make sure query finished before continuing
			this.inherited(arguments);
			if (this.contentNode) {
				// to prevent calling onLoadTemplate function twice when redrawing the widget
				// avoid using contentNode.set("href", "") because the function will throw error if empty value pass in the parameter
				this.contentNode.href = "";
			}
		},

		_onChangeResults: function() {
			// summary: update view with new count if result count has changed
			this.set("message");
			this.publishDomChange();
		},

		_onResize: function() {
			// summary: listen for resize events if there are section of template to align
			const {
				_keysToAlign,
				_plotFirstColumnWidth,
				bImageAboveAttrs,
				bPlot,
				bPopup,
				containerNode,
				expandAllGroups,
				flexHeight,
				galleryAttributeWidth,
				plotNode,
				scrollNode,
			} = this;

			const contentNode = this.getContentRoot();

			let scrollTop = scrollNode ? scrollNode.scrollTop : 0;
			let scrollLeft;

			// handle grouped gallery 
			var jContent;
			var jTable;
			var jBody;

			if (bPlot) {
				// grouped gallery has different scrolling node. Save grouped gallery vertical scroll position
				jContent = $(contentNode);
				jTable = $(plotNode);
				jBody = jTable.children("tbody");
				scrollLeft = jBody.scrollLeft();
				scrollTop = jBody.scrollTop();
			}

			this._togglePlaceholder();
			this._unfreezeGalleryView();
			this.set("message");

			csiGallery.resizeBlocks(
				contentNode,
				_keysToAlign,
				bPlot,
				bImageAboveAttrs && !galleryAttributeWidth
			);

			// if printing or view cannot scroll on its own, then finished
			if (state.get("print") || !this.canScrollAutomatically()) {
				return;
			}

			if (bPlot && plotNode) {
				// handle group gallery
				const scrollbarHeight = html.getHorizontalScrollbarHeight();
				const scrollbarWidth = html.getVerticalScrollbarWidth();
				const tbody = plotNode.lastChild;
				const jHead = jTable.children("thead");
				const columnWidths = [];
				const rowHeights = [];
				const firstColumnWidth = _plotFirstColumnWidth || html.preciseWidth(jHead.find(".csi-gallery-table-group").get(0));
				const {scrollHeight} = tbody;

				// store for next time
				this._plotFirstColumnWidth = firstColumnWidth;

				// read row heights from last cell of each row (not header)- found some cases where the cell height is slightly larger than the row height
				// (row height was whole number, while cell height was not)
				const readHeight = (i, row) => {
					rowHeights.push(Math.ceil(html.preciseHeight(row.lastChild) + 1));
				};

				jHead.children("tr").each(readHeight);
				jBody.children("tr").each(readHeight);

				// read column widths
				jBody.find("tr:first-child .csi-gallery-table-cell").each((i, col) => {
					columnWidths.push(html.preciseWidth(col));
				});

				// subtract 1 from last column width (and overall scrollWidth) since the border moves to the table level
				const scrollWidth = tbody.scrollWidth - firstColumnWidth - 1;
				--columnWidths[columnWidths.length - 1];

				// determine available space
				const tableBorderWidth = 2;
				let availableWidth = containerNode.offsetWidth - firstColumnWidth - tableBorderWidth;
				let availableHeight = this._getAvailableContentHeight() - rowHeights[0] - tableBorderWidth;

				// adjust available space due to vertical and horizontal overflow
				const hasVerticalScrollbar = html.inVerticalScrollingContainer(scrollNode);
				let isScrollingVertically = availableHeight < scrollHeight;

				if (isScrollingVertically && !hasVerticalScrollbar) {
					// only reduce available width if not within an element that is scrolling, as the goal of
					// this algorithm is to move scrolling from outside the view to within the view
					availableWidth -= scrollbarWidth;
				}

				const isScrollingHorizontally = scrollWidth > availableWidth;
				if (isScrollingHorizontally) {
					// we don't check for container scrolling horizontally as we cannot be sure that it is only horizontally
					// scrolling because of the gallery content (could be scrollbar overflows)
					availableHeight -= scrollbarHeight;

					// now that height has changed, need to re-evaluate vertical scrolling
					if (!isScrollingVertically && (availableHeight < scrollHeight)) {
						isScrollingVertically = true;

						if (!hasVerticalScrollbar) {
							availableWidth -= scrollbarWidth;
						}
					}
				}

				/*** WRITE TO DOM ***/

				jContent.addClass("csi-frozen-gallery");
				this._createFrozenColumn(jContent, jHead, jBody, rowHeights, firstColumnWidth, isScrollingHorizontally ? scrollbarHeight : 0);
				jTable.addClass(FROZEN_TABLE);
				jHead.addClass(FROZEN_THEAD);
				jBody.addClass(FROZEN_TBODY);

				if (isScrollingVertically && scrollbarWidth) {
					jContent.addClass("csi-frozen-gallery-vertical");
				}

				html.setCSSVariable(contentNode, "GalleryFrozenHeaderHeight", rowHeights[0], true);
				html.setCSSVariable(contentNode, "GalleryRowSpacerWidth", isScrollingVertically ? (scrollbarWidth + 1) : 0, true);

				// create frozen header for table
				jHead.css("max-width", Math.min(scrollWidth, availableWidth) - 1); // subtract border-right 1px
				jBody.css("max-width", availableWidth + (isScrollingVertically ? scrollbarWidth : 0));

				// set tbody and frozen column height
				jBody.css("max-height", availableHeight + (isScrollingHorizontally ? scrollbarHeight : 0));
				jContent.find(".csi-frozen-gallery-column-body").css("max-height", availableHeight);

				// set table rows height to align table rows and frozen column rows
				jTable.find(".csi-frozen-gallery-table-head > tr, .csi-frozen-gallery-table-body > tr").map(function(i, row) {
					$(row).addClass(FROZEN_ROW).css("min-width", scrollWidth);
					$(row.lastChild).css("height", rowHeights[i]);
				});

				// set table column widths and first header column height
				jHead.find(".csi-gallery-table-header").map(function(i, col) {
					const jCol = $(col);
					jCol.addClass(FROZEN_THEAD_CELL)
						.css("min-width", columnWidths[i]);

					if (i === 0) {
						jCol.css("height", rowHeights[0]);
					}
				});

				// set each table cell width to align column correctly
				jBody.find(".csi-gallery-table-cell").map(function(i, col) {
					var count = columnWidths.length;
					var pos = i % count;
					var colWidth = columnWidths[pos];
					var jCol = $(col);
					jCol.addClass(FROZEN_TBODY_CELL)
						.css({"max-width": colWidth, "min-width": colWidth});
					if (expandAllGroups) {
						jCol.children(".galleryViewPlotContent").addClass(FROZEN_CELL_PLOT_CONTENT);
					}
				});

				if (isScrollingHorizontally && !isScrollingVertically) {
					// if there is only horizontal scrollbar, gallery need to resize to align blocks correctly
					csiGallery.resizeBlocks(
						contentNode,
						_keysToAlign,
						bPlot,
						bImageAboveAttrs && !galleryAttributeWidth
					);
				}

				this._updateFrozenScrolling(scrollLeft, scrollTop);
			} else if (!bPlot && scrollNode) {
				if (!flexHeight && !bPopup) {
					scrollNode.classList.add("csi-gallery-view-content-overflow");
					html.setPixels(scrollNode, html.MAXHEIGHT, this._getAvailableContentHeight());
				}

				scrollNode.scrollTop = scrollTop;
			}

			this._updateScrollShadows();
		},

		/**
		 * Return available height for gallery view content
		 * @return {number}
		 */
		_getAvailableContentHeight() {
			const {
				flexHeight,
				messageNode,
				scrollNode,
			} = this;

			if (flexHeight) {
				return scrollNode.offsetHeight;
			}

			const viewBottomMargin = 10;
			const containerHeight = html.getAvailableHeightWithScrollbarAllowance(scrollNode);
			const messageNodeHeight = messageNode.domNode.offsetHeight + viewBottomMargin;
			return containerHeight - messageNodeHeight;
		},

		/**
		 * Create frozen column for gallery view
		 * @param {jQueryObject} jContent
		 * @param {jQueryObject} jHead
		 * @param {jQueryObject} jBody
		 * @param {number[]} rowHeights
		 * @param {number} firstColumnWidth
		 * @param {number} spacerHeight
		 */
		_createFrozenColumn: function(jContent, jHead, jBody, rowHeights, firstColumnWidth, spacerHeight) {
			var frozenColumn = html.create("div", {"class": "csi-frozen-gallery-column"}, jContent.get(0), "first");
			var frozenColumnHead = html.create("div", {"class": "csi-frozen-gallery-column-head"}, frozenColumn);
			var frozenColumnBody = html.create("div", {"class": "csi-frozen-gallery-column-body"}, frozenColumn);

			rowHeights.forEach((h, i) => {
				html.create("tr", null, i ? frozenColumnBody : frozenColumnHead);
			});

			// clone first column of table to frozen column and hide the first column of gallery
			jContent.find(".csi-frozen-gallery-column-head tr").append(
				jHead.find(".csi-gallery-table-group")
					.clone()
					.css("height", rowHeights[0])
					.css("width", firstColumnWidth)
			);

			// apply min-width to hidden first column as well so that when the table is unfrozen (and these cells are made visible),
			// this column has the same min-width as before
			jHead.find(".csi-gallery-table-group")
				.addClass(FROZEN_TABLE_HIDDEN_CELL)
				.css("min-width", firstColumnWidth);

			jBody.find(".csi-gallery-table-header").each(function(i, col) {
				i += 1;
				var jCol = $(col);
				var clone = jCol.clone();
				clone.css("min-height", rowHeights[i]);
				clone.css("min-width", firstColumnWidth);
				var selector = "." + "csi-frozen-gallery-column-body tr:nth-child" + "(" + i + ")";
				jContent.find(selector).append(clone);

				jCol.addClass(FROZEN_TABLE_HIDDEN_CELL)
					.css("min-width", firstColumnWidth);
			});

			if (spacerHeight) {
				html.setCSSVariable(frozenColumn, "GalleryColumnSpacerHeight", spacerHeight, true);

				domConstruct.create("div", {
					className: "csi-frozen-gallery-column-spacer",
				}, frozenColumn);
			}
		},

		/**
		 * unfreeze gallery view
		 */
		_unfreezeGalleryView: function() {
			var jContent = $(this.getContentRoot());
			var reset = {
				"height": "",
				"width": "",
				"max-width": "",
				"min-width": "",
				"max-height": "",
				"min-height": "",
			};
			var jGallery = jContent.closest(".csiDialogScroll");
			jGallery.removeClass("csi-gallery-view-content-overflow");
			if (!this.bPopup) {
				jGallery.css("max-height", "");
			}
			jContent.removeClass("csi-frozen-gallery");
			jContent.removeClass("csi-frozen-gallery-vertical");
			jContent.find(".csi-frozen-gallery-column").remove();
			jContent.find("." + FROZEN_TABLE_HIDDEN_CELL).removeClass(FROZEN_TABLE_HIDDEN_CELL);
			jContent.find("." + FROZEN_CELL_PLOT_CONTENT).css(reset).removeClass(FROZEN_CELL_PLOT_CONTENT);
			jContent.find("." + FROZEN_TBODY_CELL).css(reset).removeClass(FROZEN_TBODY_CELL);
			jContent.find("." + FROZEN_THEAD_CELL).css(reset).removeClass(FROZEN_THEAD_CELL);
			jContent.find("." + FROZEN_ROW).css(reset).removeClass(FROZEN_ROW);
			jContent.find("." + FROZEN_TBODY).css(reset).removeClass(FROZEN_TBODY);
			jContent.find("." + FROZEN_THEAD).css(reset).removeClass(FROZEN_THEAD);
			jContent.find("." + FROZEN_TABLE).removeClass(FROZEN_TABLE);
		},

		_processActions: function(/*Context*/ctx, /*DOMNode*/refNode, /*Actions*/actions, /*Boolean*/bEmpty) {
			// summary: output actions in block
			var domNode = this._getBlockActionNode(refNode);
			if (domNode) {
				if (bEmpty) {
					html.destroyChildren(domNode);
				}

				actions.toHtml(ctx, domNode);
			}
		},

		/**
		 * @override
		 * Render images in gallery view (other than main image) using smallest size
		 */
		_processDefinition(ctx, resource, element) {
			if ((resource instanceof Heading) && !resource.bFixedKey && (resource.m_format === types.FORMAT_IMAGE)) {
				const {prefImageSize} = ctx;
				const isReadOnly = ctx.isReadOnly();

				ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
				ctx.setReadOnly(true);

				csiHeading.toHtml(ctx, resource, element);
				element.classList.add("csiNodeImages");

				ctx.prefImageSize = prefImageSize;
				ctx.setReadOnly(isReadOnly);
			} else {
				return this.inherited(arguments);
			}
		},

		_redraw: function() {
			// summary: reset DOM
			html.setVisible(this.moreNode, false);
			this.set("message", "");
			this.plotNode = null;
			this.inherited(arguments);
		},

		/**
		 * Redraw block
		 * @param {HTMLElement} refNode 
		 */
		_redrawRefNode(refNode) {
			// it's possible that another redraw has happened since the element was clicked and so it is no longer in the DOM
			if (html.inDOM(refNode)) {
				const qr = this.getQueryResultByDomNode(refNode);
				const ctx = qr.getContext();

				ctx.preRollup();
				this._toHtmlResult(ctx, refNode.parentNode, null, refNode, this._getBlockActions(), false, true);
				ctx.postRollup();
			}
		},

		/**
		 * @override
		 * Redraw block containing given element
		 */
		_redrawNode(element) {
			var refNode = this.getRefNode(element);
			if (refNode) {
				this._redrawRefNode(refNode);
				this.when(waitForImagesToLoad(), () => this._endView());
			} else {
				this._redraw();
			}
		},

		/**
		 * @override
		 * Redraw given blocks
		 */
		_redrawNodes(refNodes) {
			for (const refNode of refNodes) {
				this._redrawRefNode(refNode);
			}

			this.when(waitForImagesToLoad(), () => this._endView());
		},

		_refreshWidget: function() {
			// summary: reset view configuration and data
			this._resetLevels();
			this.inherited(arguments);
		},

		_setMessageAttr: function(/*String?*/text) {
			// summary: update text indicating result count
			if (!this.messageNode || !this.bShowMessageNode) {
				return;
			}

			if ((text == null) && !state.get("print")) {
				// if slim view, then only display message if no results
				if ((this.queryTotalCount == 0) || !this.defView.isSlim()) {
					text = this.getQueryResultMessage();
				}
			}

			this.messageNode.set("text", text);
		},

		_toHtmlResult: function(/*Context*/ctx, /*DOMNode*/refNodeParent, /*DOMNode?*/refNode, /*DOMNode?*/refNodeNext, /*Actions?*/actions, /*Boolean*/bNew, /*Boolean*/bReplace) {
			// summary: render node block in context under given parent; if replacing existing result, then pass existing result as refNodeNext
			var blockNode = this.blockNode.cloneNode(true);
			var qrParent = this.getQueryResult();
			var level = qrParent.level.childLevel;
			var qrNext = refNodeNext && this.getQueryResultByDomNode(refNodeNext);
			var qr;

			if (bReplace) {
				qr = qrNext;

				// apply styling of previous block to new block to prevent jitters
				if (this._keysToAlign) {
					csiGallery.copyBlockStyling(refNodeNext, blockNode, this._keysToAlign, this.bImageAboveAttrs && !this.galleryAttributeWidth);
				}
			} else {
				qr = this._createQueryResult({
					bResultNode: true,
					level: level,
					parentResult: qrParent,
					parentUrl: qrParent.url,
					url: ctx.getNodeURL()
				});

				// add result to view unless just replacing existing result
				this._insertQueryResult(qr, bNew, bNew ? qrNext : null);
			}

			// add to DOM
			refNode = refNode || blockNode;
			this.setRefNodeId(refNode, qr.id);
			this._addBlockStyling(refNode);
			ctx.applyNodeContext(refNode);
			qr.preProcessContext(ctx);

			// add CSS for rules
			const classes = def.processRulesCSS(ctx, level.rules);
			if (classes.length) {
				domClass.add(blockNode, classes.join(" "));
			}

			var bNewActionsBtn = this.isNewActionsButton(refNodeNext);
			if (refNodeNext && !bNewActionsBtn) {
				domConstruct.place(blockNode, refNodeNext, bReplace ? "replace" : "before");
			} else {
				refNodeParent.appendChild(blockNode);
			}

			// apply node to template
			this._processHtml(ctx, blockNode);

			// output relationship actions in desired location
			if (actions) {
				// FIX: this does similar thing as qr.renderActions - eventually we should try to reuse function
				qr.resetActionContext(ctx);
				this._processActions(ctx, blockNode, actions);
			}

			qr.postProcessContext(ctx);

			// allow highlighting if view supports selection
			if (this.allowsSelections()) {
				this.enableRefNodeHighlighting(refNode);

				if (ctx.fd.isSelection(ctx, true)) {
					this.select(refNode, true);
				}
			}

			return refNode;
		},

		_resolveView: function() {
			// summary: add view-specific actions
			var defImage = this.getImage();
			var self = this;

			this._plotAction = this.defView._addViewAction("PlotExpandCollapse", {
				m_class: "dijitReset dijitInline galleryViewPlotAction iconCollapsed",
				m_typeControl: def.ACTION_ICON
			});

			// attach listeners to image renderer to support logic when using built-in templates
			if (defImage) {
				if (!this.defView.templatePath) {
					this.own(
						topic.subscribe("/csi/refimage/draw", function(ctx, h, refNode, src, bImage) {
							if ((self === ctx.view) && (h == defImage)) {
								// don't go off source because could be shown as icon
								domClass.toggle(refNode.parentNode, csiGallery.CSS_NO_IMAGE, !bImage);
							}
						})
					);
				}

				this.own(
					topic.subscribe("/csi/refimage/load", function(ctx, h, img) {
						if ((self === ctx.view) && (h == defImage)) {
							if (self.galleryImageHeight) {
								html.setPixels(img, html.MAXHEIGHT, self.galleryImageHeight);
							}
							if (self.galleryImageWidth) {
								html.setPixels(img, html.MAXWIDTH, self.galleryImageWidth);
							}
						}
					})
				);
			}

			this.inherited(arguments);
		},

		_getGroupCell: function(/*Number*/row, /*Number*/column) {
			// summary: return cell representing row and column
			var tbody = this.plotNode.lastChild;
			return tbody.childNodes[row || 0].childNodes[(column || 0) + 1];
		},

		_getGroupCellByContext: function(/*Context*/ctx) {
			// summary: find cell containing node in context based on current values
			var row = this._getGroupValueIndex(ctx, this._groupRowSpec, this._groupRowValues);
			var column = this._getGroupValueIndex(ctx, this._groupColSpec, this._groupColValues);
			return this._getGroupCell(row, column);
		},

		_getGroupValueIndex: function(/*Context*/ctx, /*Spec*/spec, /*Store*/values) {
			// summary: return row/column index for value in store
			if (!spec) return null;

			var value = csiHeading.toFilterValue(ctx, spec.heading);
			var item = values.get(value);
			return item ? item[values.indexProperty] : null;
		},

		_setPlotCellCount: function(cell, count) {
			var headerNode = query(".galleryViewPlotHeader", cell)[0];
			var countNode = query(".galleryViewPlotCount", headerNode)[0];

			domClass.toggle(headerNode, "galleryViewPlotHeaderCount", !!count);

			if (count) {
				html.setVisible(headerNode, true);
				html.setInnerText(countNode, "(" + count + ")");
			} else {
				html.setVisible(headerNode, false);
			}
		},

		plotExpandCollapse: function(/*DOMNode*/domNode) {
			var table = this.plotNode;
			var thead = table.firstChild;
			var tbody = table.lastChild;
			var row = csiGallery.getGroupRow(domNode);
			var column = csiGallery.getGroupColumn(domNode);
			var collapse = !query(".iconCollapsed", domNode.parentNode).length;
			var cssColumn = ".plotColumn" + column;
			var cssRow = ".plotRow" + row;
			var groupCell = ((row != -1) && (column != -1)) ? this._getGroupCell(row, column) : null;
			var cellQuery = "";

			var toggle = function(button) {
				domClass.toggle(button, "iconCollapsed", collapse);
				domClass.toggle(button, "iconExpanded", !collapse);
			};

			var toggleQuery = function(cssQuery, domScope) {
				query(cssQuery + " .galleryViewPlotAction", domScope).forEach(toggle);
			};

			if (groupCell) {
				// single cell
				cellQuery = cssRow + " " + cssColumn;
			} else if (column != -1) {
				// collapse/expand column
				cellQuery = cssColumn;
			} else if (row != -1) {
				// collapse/expand row
				cellQuery = cssRow;
			}

			// determine if query is necessary by checking for non-hidden action and content cells
			var contentNodes = csiGallery.getGroupContentNodes(table, cellQuery);
			var bQuery = !collapse && contentNodes.some((contentNode) => html.isVisible(contentNode) && html.isVisible(contentNode.previousSibling) && query(".iconCollapsed", contentNode.previousSibling).length);

			// toggle all buttons matching query
			toggleQuery(cellQuery, table);
			// now update table/row/column actions based on changes
			var nl = query(".galleryViewPlotHeaderCount " + (collapse ? ".iconExpanded" : ".iconCollapsed"), tbody);
			if (nl.length) {
				var rows = {};
				var cols = {};

				if (collapse) {
					// if any cell is collapsed then also collapse table action icon
					toggleQuery("", thead.firstChild.firstChild);

					// row/column state determined by if any cells in row/column that need to expand
					nl = query("td .iconCollapsed", tbody);
				}

				nl.forEach(function(button) {
					rows[csiGallery.getGroupRow(button)] = true;
					cols[csiGallery.getGroupColumn(button)] = true;
				}, this);

				// sync row expand/collapse action
				var rbuttons = query("th .galleryViewPlotAction", tbody).filter(function(button) {
					var r = csiGallery.getGroupRow(button);
					return (r >= 0) && (collapse == !!rows[r]);
				}, this);

				// sync column expand/collapse action
				var cbuttons = query(".galleryViewPlotAction", thead).filter(function(button) {
					var c = csiGallery.getGroupColumn(button);
					return (c >= 0) && (collapse == !!cols[c]);
				}, this);

				cbuttons.forEach(toggle);
				rbuttons.forEach(toggle);
			} else {
				// all cells expanded/collapsed, so sync row/column header states
				toggleQuery("th", table);
			}

			if (!bQuery) {
				// show/hide results that already exist
				this._setPlotContentDisplay(contentNodes, !collapse);
				this.set("message");
				this.resize();
				return;
			}

			// FIX: query here is for whole table/row/column, even if some have already been expanded - might be better if Values query returned URLs in each cell
			// so we can just query by URL
			var qr = this.getQueryResult();
			var store = this.getMainQueryLevel().createStore(qr.getContext());
			var qn = store.createQuery();
			_filterDimension(qn, this._groupRowSpec, this._groupRowValues, row);
			_filterDimension(qn, this._groupColSpec, this._groupColValues, column);
			store.addFilterQuery(qn);

			var queryObject = this.get("queryForServer");
			var queryOptions = this.getQueryResultOptions(qr);

			return when(store.query(queryObject, queryOptions), lang.hitch(this, function(results) {
				if (this.isValidView()) {
					// place results in appropriate cell
					var ctx = this.getContext(csi.EMPTY_URL);
					ctx.preRollup();

					// show results that already exist
					this._setPlotContentDisplay(contentNodes, true);

					// plot any cells that have yet to be plotted
					return this._plotNodes(results, ctx, groupCell).then(lang.hitch(this, function() {
						if (this.isValidView()) {
							ctx.postRollup();
							this.set("message");
							this.resize();
						}
					}));
				}
			}));
		},

		_plotNodes: function(/*Node[]*/nodes, /*Context*/ctx, /*DOMNode?*/cell) {
			// summary: iterate through all nodes and decide in which cell to plot the node
			// NOTE: assumes initially empty target cells returned by placement function
			// NOTE: assumes this.cacheView to contain row & col headings, otherwise all nodes will end up in the same row
			var actions = this._getBlockActions();
			var cellNodes = [];
			var dfd = new Deferred();

			csi.forEachWithTimeout(
				nodes,
				20,
				function(groupNodes) {
					if (!this.isValidView()) return;

					// render nodes into table
					var cellNode = cell;

					ctx.forEach(groupNodes, function(ctx) {
						if (!cell) {
							// if plotting nodes across multiple cells, then test to see if node already plotted;
							// currently that could be the case if showing multiple cells when some are already shown
							if (this.getQueryResult(ctx.getNodeURL())) {
								return;
							}

							cellNode = this._getGroupCellByContext(ctx);
						}

						if (cellNode) {
							var contentNode = csiGallery.getGroupContentNodes(cellNode)[0];

							// TA19903: set the number of blocks in cell based on groupItemsPerRow
							if (this.groupItemsPerRow) {
								if (!contentNode.lastChild || (contentNode.lastChild.children.length % this.groupItemsPerRow == 0)) {
									domConstruct.create("div", {"class": "galleryViewPlotRow"}, contentNode);
								}

								contentNode = contentNode.lastChild;
							}

							this._toHtmlResult(ctx, contentNode, null, null, actions);

							if (cellNodes && (cellNodes.indexOf(cellNode) == -1)) {
								cellNodes.push(cellNode);
							}
						}
					}, this);
				},
				null,
				function() {
					if (!this.expandAllGroups) {
						array.forEach(cellNodes, function(cellNode) {
							this._setPlotCellCount(cellNode, query(".galleryBlock", cellNode).length);
						}, this);
					}

					this.when(waitForImagesToLoad(), () => {
						dfd.resolve(nodes);
					});
				},
				this
			);

			return dfd;
		},

		_setPlotContentDisplay: function(/*NodeList*/contentNodes, /*Boolean*/bShow) {
			// summary: show/hide galleryViewPlotContent results
			var n = 0;

			contentNodes.forEach(function(contentNode) {
				if (html.isVisible(contentNode) != bShow) {
					csiGallery.getBlocks(contentNode).forEach(function(refNode) {
						this.getQueryResultByDomNode(refNode).bHidden = !bShow;
						++n;
					}, this);

					html.setVisible(contentNode, bShow);
				}
			}, this);

			this.set("queryDisplayCount", this.get("queryDisplayCount") + (bShow ? n : -n));
		},

		/**
		 * Synchronize scrolling of plot table
		 * @param {number} [scrollLeft]
		 * @param {number} [scrollTop]
		 */
		_updateFrozenScrolling(scrollLeft, scrollTop) {
			const {plotNode} = this;
			if (!plotNode) {
				return;
			}

			const plotHead = plotNode.querySelector("thead");
			const plotBody = plotNode.querySelector("tbody");

			if (scrollLeft === undefined) {
				// get scroll positions from body if not provided
				scrollLeft = plotBody.scrollLeft;
				scrollTop = plotBody.scrollTop;
			} else {
				// update scroll position of body if provided
				plotBody.scrollLeft = scrollLeft;
				plotBody.scrollTop = scrollTop;
			}

			// if gallery is frozen, then update left and top headers as well (otherwise this will be done in _onResize)
			const frozenBody = this.getContentRoot().querySelector(".csi-frozen-gallery-column-body");
			if (frozenBody) {
				plotHead.scrollLeft = scrollLeft;
				frozenBody.scrollTop = scrollTop;
			}
		},

		/**
		 * Update display of scroll shadows for non-grouped views
		 */
		_updateScrollShadows() {
			const {
				bPlot,
				scrollNode,
				scrollTopNode,
				scrollBottomNode
			} = this;

			html.setVisible(scrollTopNode, !bPlot && !html.isScrolledToTop(scrollNode));
			html.setVisible(scrollBottomNode, !bPlot && html.isScrollingVertically(scrollNode) && !html.isScrolledToBottom(scrollNode));
		},

		/**
		 * @override
		 * Return dropdown options for gallery custom view
		 */
		getCustomViewDropDownOptions() {
			// Image size dropdown options 
			const imageSizes = convertEnumToComponentItem(reflection.IMAGE_SIZE_ENUM);
			imageSizes.push({id: IMAGE_SIZE_CUSTOM, res: "Custom"});

			// Result count dropdown options 
			const resultCounts = this.get("querySizeStoreForCustomView");

			// Card template dropdown options 
			const cardTemplates = this.getTemplateStore();

			// Image label/Cover image
			const imageHeading = this.getImage();
			const imageLabels = imageHeading ? getCustomViewClassImageLabels(imageHeading.rc) : [];
			imageLabels.unshift({id: constants.PREFERENCE_DEFAULT, res: "ViewPreferences_DefaultValue"});

			// Items in row per group dropdown options
			const groupItemsPerRowOptions = [
				{id: "0", name: `(${constants.PREFERENCE_DEFAULT})`, value: 0},
				{id: "1", name: "1", value: 1},
				{id: "2", name: "2", value: 2},
				{id: "3", name: "3", value: 3}
			];

			// Group Headers dropdown options
			const groupHeaderStyleOptions = [
				{id: constants.PREFERENCE_DEFAULT, res: "ViewPreferences_PlotGroupHeadersOnce"},
				{id: constants.GALLERY_HEADERS_PER_PAGE, res: "ViewPreferences_PlotGroupHeadersPerPage"},
				{id: constants.GALLERY_HEADERS_PER_GROUP, res: "ViewPreferences_PlotGroupHeadersPerGroup"}
			];

			// Paper size and paper orientation dropdown options
			const options = this.inherited(arguments);

			return {
				...options,
				cardTemplates: cardTemplates?.data,
				groupHeaderStyleOptions,
				groupItemsPerRowOptions,
				imageLabels,
				imageSizes,
				resultCounts: resultCounts.data,
			};
		},

		/**
		 * @override
		 * Determines if this is a gallery view with group settings 
		 */
		onCustomViewDataManagementOptions(options) {
			this.inherited(arguments);
			options.isGalleryView = isDefined(this.groupSettings);
		}
	});
});